export const daysFromToday = (numberOfDays) => {
  let futureDate = new Date();
  const today = futureDate;
  
  futureDate.setDate(today.getDate() + numberOfDays);

  return futureDate;
}
